var _rect, _rect2, _rect3, _rect4, _rect5, _line, _line2, _line3, _line4, _line5, _line6, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyComputerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 16.5,
    width: 19,
    height: 32,
    fill: "#757575",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 20.5,
    width: 33,
    height: 17,
    fill: "#757575",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 30,
    height: 14,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 38.5,
    width: 4,
    height: 6,
    fill: "#A7A3A3",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 45.5,
    width: 18,
    height: 3,
    fill: "#B3B3B3",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 39.5,
    x2: 47,
    y2: 39.5,
    stroke: "#B7B7B7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 32.5,
    x2: 44,
    y2: 32.5,
    stroke: "#A9A9A9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: 32,
    x2: 43.5,
    y2: 20,
    stroke: "#A9A9A9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 20.5,
    x2: 38,
    y2: 20.5,
    stroke: "#A9A9A9"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 23.5,
    x2: 40,
    y2: 23.5,
    stroke: "#A7A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 28.5,
    x2: 42,
    y2: 28.5,
    stroke: "#A7A3A3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44,
    width: 2,
    height: 2,
    fill: "#399A3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyComputerLogo);
export default __webpack_public_path__ + "static/media/myComputer-logo.a1bee139d4cf0336bd304e33198dd458.svg";
export { ForwardRef as ReactComponent };